import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InstitutionsService } from '../../service/main/institutions.service';
import { ToastrService } from '../../service/common/toastr.service';

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.css']
})
export class InstitutionsComponent implements OnInit {

  institution: any = null;
  isEditable: boolean = false;

  constructor(private router: Router,
    private institutionsService: InstitutionsService,
    private toastr: ToastrService,) {
  }

  ngOnInit() {
    this.institutionsService.getAllInstitutions().subscribe(res => {
      if (res) {
        this.institution = {
          title: res.title,
          id: res.companyID,
          location: res.location,
          address: res.address,
          bankAccount: res.bankAccount,
          contactID: res.contactPersonID,
          contactEmail: res.contactEmail,
          contactName: res.contactName,
          contactPhone: res.contactPhone,
          identifier: res.identifier,
          caleUser: res.user,
          calePassword: res.password,
          totalIncome: res.totalIncome,
          parkings: res.parkings.length,
        }
      }
    });
  }


  addinstitution() {
    this.router.navigate(['/institutions/add-institutions']);
  }
  showEditable() {
    this.isEditable = !this.isEditable;
  }
  saveEditInfo(formValues) {
    let editInfo = {
      companyID: this.institution.id,
      contactPersonID: this.institution.contactID,
      title: formValues.title,
      identifier: formValues.identifier,
      bankAccount: formValues.bankAccount,
      address: formValues.address,
      location: formValues.location,
      contactName: formValues.contactName,
      contactPhone: formValues.contactPhone,
      contactEmail: formValues.contactEmail,
    }
    this.institutionsService.editInstitution(editInfo).subscribe(res => {
      if (res) {
        this.isEditable = !this.isEditable;
        this.toastr.success('Institution was successfully edited.');
      }
    }, err => {
      this.toastr.error('An error has occurred while editing the institution.');
    });
  }


}
